<script setup lang="ts">
import {computed, ref} from "vue";
import ChatAttachedMessages from "@/components/main/chat-panel/modals/ChatAttachedMessages.vue";
import moment from "moment/moment";
import { AttachedMessage } from "@/store/chats";
import {applyChatMessagePlaceholders} from "@/utils/textHelpers";

const props = defineProps<{
	attachedMessage: AttachedMessage
}>()

const $attachedMessages = ref<InstanceType<typeof ChatAttachedMessages> | null>(null);

const getDialogDate = (date: string) => moment(date).format("DD.MM.YYYY HH:mm");

const messageHtml = computed(() =>
	applyChatMessagePlaceholders(
		props.attachedMessage?.Text ?? '',
		props.attachedMessage?.Links,
		props.attachedMessage?.Bills
	).replaceAll('\n', '<br>')
)
</script>

<template>
	<chat-attached-messages
		ref="$attachedMessages"
		:title="$t('chat_all_replies')"
	/>
	<div class="answered-message">
		<div class="answered-message__lable" />
		<div class="answered-message__body">
			<div class="answered-message__body-header">
				<div class="answered-message__body-header-name">
					{{ props.attachedMessage.Sender.Name }}
				</div>
				<div class="answered-message__body-header-date">
					{{ getDialogDate(props.attachedMessage.Date) }}
				</div>
			</div>
			<div
				class="answered-message__body-text"
				v-html="messageHtml"
			/>
			<div
				v-if="props.attachedMessage.AttachedMessagesCount"
				class="answered-message__body-more"
				@click.stop="$attachedMessages.onOpen(props.attachedMessage.Id)"
			>
				{{ $t('chat_more_messages') }}
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
.answered-message {
	display: flex;
	margin-top: 4px;

	&__lable {
		display: flex;
		min-width: 2px;
		max-width: 2px;
		min-height: 100%;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		background-color: #3F884F;
		margin-right: 4px;
	}

	&__body {
		display: flex;
		flex-direction: column;
		width: 100%;
		color: #4D4D4D;

		&-header {
			display: flex;
			align-items: center;
			position: relative;
			gap: 4px;
			margin-bottom: 2px;

			&-name {
				font-size: 14px;
				line-height: 18px;
				font-weight: 500;
				color: #4D4D4D;
			}

			&-date {
				font-size: 12px;
				line-height: 16px;
				color: #979797;
			}
		}

		&-text {
			font-size: 14px;
			line-height: 15px;
		}

		&-more {
			font-size: 14px;
			line-height: 18px;
			color: #438451;
			margin-top: 2px;
			cursor: pointer;

			&:hover {
				text-decoration: underline;
			}
		}
	}
}
</style>
